/* Generated by ai2react v0.102.0 - 2021-12-23 02:24 */
/* ai file: medicina.ai */

import { makeAi2React } from 'ai2react'
import img0 from '././img/medicina-large.svg'
import img1 from '././img/medicina-mobile.svg'

const styles = `
  #g-medicina-box ,
  #g-medicina-box .g-artboard {
    margin:0 auto;
  }
  #g-medicina-box p {
    margin:0;
  }
  #g-medicina-box .g-aiAbs {
    position:absolute;
  }
  #g-medicina-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-medicina-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-medicina-box .g-aiPointText p { white-space: nowrap; }
  #g-medicina-large {
    position:relative;
    overflow:hidden;
  }
  #g-medicina-large p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-medicina-large .g-pstyle0 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-medicina-large .g-pstyle1 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:0em;
    font-size:10px;
  }
  #g-medicina-large .g-pstyle2 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-medicina-large .g-pstyle3 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.02em;
    font-size:10px;
  }
  #g-medicina-large .g-pstyle4 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:13px;
  }
  #g-medicina-large .g-pstyle5 {
    height:13px;
  }
  #g-medicina-large .g-pstyle6 {
    font-weight:800;
    height:13px;
  }
  #g-medicina-large .g-pstyle7 {
    height:13px;
    letter-spacing:0em;
  }
  #g-medicina-large .g-pstyle8 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-medicina-large .g-pstyle9 {
    height:13px;
    letter-spacing:-0.032em;
  }
  #g-medicina-large .g-pstyle10 {
    height:13px;
    letter-spacing:-0.051em;
  }
  #g-medicina-large .g-pstyle11 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-medicina-large .g-pstyle12 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.036em;
  }
  #g-medicina-large .g-pstyle13 {
    color:rgb(96,96,96);
  }
  #g-medicina-large .g-cstyle0 {
    letter-spacing:0em;
  }
  #g-medicina-large .g-cstyle1 {
    letter-spacing:-0.019em;
  }
  #g-medicina-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-medicina-large .g-cstyle3 {
    letter-spacing:-0.021em;
  }
  #g-medicina-large .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-medicina-large .g-cstyle5 {
    letter-spacing:-0.039em;
  }
  #g-medicina-large .g-cstyle6 {
    letter-spacing:-0.047em;
  }
  #g-medicina-large .g-cstyle7 {
    letter-spacing:-0.034em;
  }
  #g-medicina-large .g-cstyle8 {
    letter-spacing:-0.084em;
  }
  #g-medicina-large .g-cstyle9 {
    letter-spacing:-0.036em;
  }
  #g-medicina-large .g-cstyle10 {
    letter-spacing:-0.053em;
  }
  #g-medicina-large .g-cstyle11 {
    letter-spacing:-0.037em;
  }
  #g-medicina-large .g-cstyle12 {
    letter-spacing:-0.035em;
  }
  #g-medicina-large .g-cstyle13 {
    letter-spacing:-0.029em;
  }
  #g-medicina-large .g-cstyle14 {
    letter-spacing:-0.086em;
  }
  #g-medicina-large .g-cstyle15 {
    letter-spacing:-0.032em;
  }
  #g-medicina-large .g-cstyle16 {
    letter-spacing:-0.042em;
  }
  #g-medicina-large .g-cstyle17 {
    letter-spacing:-0.043em;
  }
  #g-medicina-large .g-cstyle18 {
    letter-spacing:-0.051em;
  }
  #g-medicina-large .g-cstyle19 {
    letter-spacing:-0.041em;
  }
  #g-medicina-large .g-cstyle20 {
    letter-spacing:-0.125em;
  }
  #g-medicina-large .g-cstyle21 {
    letter-spacing:-0.11em;
  }
  #g-medicina-large .g-cstyle22 {
    letter-spacing:-0.121em;
  }
  #g-medicina-large .g-cstyle23 {
    letter-spacing:-0.033em;
  }
  #g-medicina-large .g-cstyle24 {
    letter-spacing:-0.117em;
  }
  #g-medicina-large .g-cstyle25 {
    letter-spacing:-0.04em;
  }
  #g-medicina-large .g-cstyle26 {
    letter-spacing:-0.085em;
  }
  #g-medicina-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-medicina-mobile p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-medicina-mobile .g-pstyle0 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-medicina-mobile .g-pstyle1 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:13px;
  }
  #g-medicina-mobile .g-pstyle2 {
    height:13px;
  }
  #g-medicina-mobile .g-pstyle3 {
    font-weight:800;
    height:13px;
  }
  #g-medicina-mobile .g-pstyle4 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-medicina-mobile .g-pstyle5 {
    height:13px;
    letter-spacing:-0.051em;
  }
  #g-medicina-mobile .g-pstyle6 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
  }
  #g-medicina-mobile .g-pstyle7 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:0em;
    font-size:10px;
  }
  #g-medicina-mobile .g-pstyle8 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.02em;
    font-size:10px;
  }
  #g-medicina-mobile .g-pstyle9 {
    height:13px;
    letter-spacing:0em;
  }
  #g-medicina-mobile .g-pstyle10 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-medicina-mobile .g-pstyle11 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.036em;
  }
  #g-medicina-mobile .g-pstyle12 {
    color:rgb(96,96,96);
  }
  #g-medicina-mobile .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-medicina-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-medicina-mobile .g-cstyle2 {
    letter-spacing:-0.021em;
  }
  #g-medicina-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-medicina-mobile .g-cstyle4 {
    letter-spacing:-0.039em;
  }
  #g-medicina-mobile .g-cstyle5 {
    letter-spacing:-0.047em;
  }
  #g-medicina-mobile .g-cstyle6 {
    letter-spacing:-0.034em;
  }
  #g-medicina-mobile .g-cstyle7 {
    letter-spacing:-0.053em;
  }
  #g-medicina-mobile .g-cstyle8 {
    letter-spacing:-0.036em;
  }
  #g-medicina-mobile .g-cstyle9 {
    letter-spacing:-0.035em;
  }
  #g-medicina-mobile .g-cstyle10 {
    letter-spacing:-0.029em;
  }
  #g-medicina-mobile .g-cstyle11 {
    letter-spacing:-0.086em;
  }
  #g-medicina-mobile .g-cstyle12 {
    letter-spacing:-0.032em;
  }
  #g-medicina-mobile .g-cstyle13 {
    letter-spacing:-0.042em;
  }
  #g-medicina-mobile .g-cstyle14 {
    letter-spacing:-0.043em;
  }
  #g-medicina-mobile .g-cstyle15 {
    letter-spacing:-0.051em;
  }
  #g-medicina-mobile .g-cstyle16 {
    letter-spacing:-0.041em;
  }
  #g-medicina-mobile .g-cstyle17 {
    letter-spacing:-0.125em;
  }
  #g-medicina-mobile .g-cstyle18 {
    letter-spacing:-0.037em;
  }
  #g-medicina-mobile .g-cstyle19 {
    letter-spacing:-0.121em;
  }
  #g-medicina-mobile .g-cstyle20 {
    letter-spacing:-0.11em;
  }
  #g-medicina-mobile .g-cstyle21 {
    letter-spacing:-0.033em;
  }
  #g-medicina-mobile .g-cstyle22 {
    letter-spacing:-0.117em;
  }
  #g-medicina-mobile .g-cstyle23 {
    letter-spacing:-0.04em;
  }
  #g-medicina-mobile .g-cstyle24 {
    letter-spacing:-0.019em;
  }
  #g-medicina-mobile .g-cstyle25 {
    letter-spacing:-0.084em;
  }
  #g-medicina-mobile .g-cstyle26 {
    letter-spacing:-0.085em;
  }

`

const html = props => `
<div id="g-medicina-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-medicina-large" class="g-artboard" style="width:940px; height:502.75px;" data-aspect-ratio="1.87" data-min-width="940">
<div style=""></div>
    <img id="g-medicina-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:53.6535%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:55.6453%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:58.5501%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:60.5421%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:63.4553%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:65.447%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:68.3518%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:70.3437%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:73.3436%;width:44px;">
      <p class="g-pstyle2"> NE<span class="g-cstyle0">M</span></p>
    </div>
    <div id="g-ai0-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:78.9305%;width:60px;">
      <p class="g-pstyle3">Ra<span class="g-cstyle1">n</span>k<span class="g-cstyle1">in</span>g<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.1299%;margin-top:-6.8px;left:95.6193%;width:59px;">
      <p class="g-pstyle2"><span class="g-cstyle2">A</span>rancel<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:6.2475%;margin-top:-8.4px;left:1.9109%;width:91px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle2">e</span>r<span class="g-cstyle2">s</span>ida<span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:21.9893%;width:45px;">
      <p class="g-pstyle2">Sed<span class="g-cstyle0">e</span></p>
    </div>
    <div id="g-ai0-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:29.8143%;width:63px;">
      <p class="g-pstyle2">M<span class="g-cstyle3">í</span>n <span class="g-cstyle2">P</span>o<span class="g-cstyle2">n</span><span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:37.4322%;width:70px;">
      <p class="g-pstyle2">Prom P<span class="g-cstyle2">o</span>n<span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:45.813%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle2">M</span>áx Po<span class="g-cstyle2">n</span><span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:85.7083%;width:64px;">
      <p class="g-pstyle3">Va<span class="g-cstyle1">c</span>a<span class="g-cstyle1">n</span>te<span class="g-cstyle0">s</span></p>
    </div>
    <div id="g-ai0-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:53.6058%;width:41px;">
      <p class="g-pstyle2">len<span class="g-cstyle0">g</span></p>
    </div>
    <div id="g-ai0-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:58.5978%;width:39px;">
      <p class="g-pstyle3"><span class="g-cstyle1">m</span>a<span class="g-cstyle0">t</span></p>
    </div>
    <div id="g-ai0-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:63.4631%;width:41px;">
      <p class="g-pstyle2">cie<span class="g-cstyle0">n</span></p>
    </div>
    <div id="g-ai0-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:68.4707%;width:39px;">
      <p class="g-pstyle2">his<span class="g-cstyle0">t</span></p>
    </div>
    <div id="g-ai0-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:79.5572%;width:47px;">
      <p class="g-pstyle2">not<span class="g-cstyle2">a</span><span class="g-cstyle0">s</span></p>
    </div>
    <div id="g-ai0-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.3178%;margin-top:-6.8px;left:94.1747%;width:70px;">
      <p class="g-pstyle2">referen<span class="g-cstyle2">c</span>ia<span class="g-cstyle0">l</span></p>
    </div>
    <div id="g-ai0-24" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:11.4542%;margin-top:-7.6px;left:1.8633%;width:87px;">
      <p class="g-pstyle5">PUC de<span class="g-cstyle4"> </span>Ch<span class="g-cstyle4">i</span>le<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:30.338%;width:59px;">
      <p class="g-pstyle6">8<span class="g-cstyle4">0</span><span class="g-cstyle5">0</span>,1<span class="g-cstyle4">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:38.3379%;width:61px;">
      <p class="g-pstyle6">80<span class="g-cstyle6">9</span>,40<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:46.4724%;width:60px;">
      <p class="g-pstyle6">83<span class="g-cstyle7">3</span>,30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:63.4706%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:73.5579%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:79.8109%;width:46px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>0%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:87.3111%;width:37px;">
      <p class="g-pstyle6">85<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6531%;margin-top:-7.6px;left:93.3025%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span><span class="g-cstyle8">7</span><span class="g-cstyle4">.</span>35<span class="g-cstyle4">2</span><span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:1.8633%;width:134px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de San<span class="g-cstyle4">ti</span>ago de Chile<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:30.3854%;width:57px;">
      <p class="g-pstyle6">79<span class="g-cstyle7">8</span><span class="g-cstyle4">,</span>15<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:39.4966%;width:36px;">
      <p class="g-pstyle6">s/<span class="g-cstyle4">i</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:46.5041%;width:58px;">
      <p class="g-pstyle6">781<span class="g-cstyle9">,</span>05<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:58.6139%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:79.7871%;width:47px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.6367%;margin-top:-7.6px;left:93.1756%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>2<span class="g-cstyle4">5</span><span class="g-cstyle9">0</span><span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:17.6203%;margin-top:-7.6px;left:1.8633%;width:76px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de C<span class="g-cstyle4">h</span>i<span class="g-cstyle4">le</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:30.338%;width:59px;">
      <p class="g-pstyle6">77<span class="g-cstyle7">8</span><span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:38.3936%;width:60px;">
      <p class="g-pstyle6">79<span class="g-cstyle5">0</span>,5<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:46.4485%;width:58px;">
      <p class="g-pstyle6">84<span class="g-cstyle4">2</span>,<span class="g-cstyle4">1</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:53.6777%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:63.4389%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:79.8109%;width:46px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>0%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:86.9936%;width:42px;">
      <p class="g-pstyle6">19<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.8192%;margin-top:-7.6px;left:93.2867%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6<span class="g-cstyle4">.</span>52<span class="g-cstyle8">7</span><span class="g-cstyle9">.</span>90<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:20.6039%;margin-top:-7.6px;left:1.8633%;width:98px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de los <span class="g-cstyle4">A</span>ndes<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:30.3776%;width:58px;">
      <p class="g-pstyle6">77<span class="g-cstyle4">2</span>,5<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:38.3775%;width:60px;">
      <p class="g-pstyle6">78<span class="g-cstyle12">4</span><span class="g-cstyle9">,</span>06<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:46.4724%;width:60px;">
      <p class="g-pstyle6">83<span class="g-cstyle7">3</span>,<span class="g-cstyle4">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">35%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:79.8664%;width:44px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8028%;margin-top:-7.6px;left:95.3579%;width:58px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>85 UF<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-76" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:1.8633%;width:108px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de C<span class="g-cstyle4">o</span>ncepción<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:20.2987%;width:79px;">
      <p class="g-pstyle8">Co<span class="g-cstyle13">n</span>ce<span class="g-cstyle13">p</span>ció<span class="g-cstyle13">n</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:30.3537%;width:58px;">
      <p class="g-pstyle6">766,<span class="g-cstyle4">1</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:38.3697%;width:60px;">
      <p class="g-pstyle6">78<span class="g-cstyle5">0</span>,80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:46.5041%;width:58px;">
      <p class="g-pstyle6">8<span class="g-cstyle4">2</span><span class="g-cstyle14">7</span>,4<span class="g-cstyle4">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">35%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:73.6371%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:79.8425%;width:45px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:87.0175%;width:42px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7864%;margin-top:-7.6px;left:93.2629%;width:80px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6<span class="g-cstyle9">.</span>97<span class="g-cstyle4">6</span><span class="g-cstyle11">.</span>0<span class="g-cstyle4">1</span>8<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-89" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:26.77%;margin-top:-7.6px;left:1.8633%;width:102px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de<span class="g-cstyle4">l</span> De<span class="g-cstyle4">s</span>a<span class="g-cstyle4">r</span><span class="g-cstyle15">r</span><span class="g-cstyle4">o</span>ll<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:30.3458%;width:59px;">
      <p class="g-pstyle6">76<span class="g-cstyle12">4</span><span class="g-cstyle16">,</span>70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:38.457%;width:58px;">
      <p class="g-pstyle6">772<span class="g-cstyle17">,</span>70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:46.4407%;width:60px;">
      <p class="g-pstyle6">79<span class="g-cstyle6">9</span>,<span class="g-cstyle4">4</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:58.5187%;width:45px;">
      <p class="g-pstyle5">40%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:73.6371%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:79.8109%;width:46px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>0%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:87.3111%;width:37px;">
      <p class="g-pstyle6">65<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.9689%;margin-top:-7.6px;left:95.3817%;width:57px;">
      <p class="g-pstyle6">31<span class="g-cstyle4">4</span> U<span class="g-cstyle4">F</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-102" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:29.7535%;margin-top:-7.6px;left:1.8633%;width:98px;">
      <p class="g-pstyle9">U. de Valparaíso</p>
    </div>
    <div id="g-ai0-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:20.9334%;width:67px;">
      <p class="g-pstyle10">Valparaíso</p>
    </div>
    <div id="g-ai0-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:30.3537%;width:57px;">
      <p class="g-pstyle6">762.40</p>
    </div>
    <div id="g-ai0-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:38.4094%;width:54px;">
      <p class="g-pstyle6">772.10</p>
    </div>
    <div id="g-ai0-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:46.4644%;width:56px;">
      <p class="g-pstyle6">813.40</p>
    </div>
    <div id="g-ai0-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:53.7096%;width:42px;">
      <p class="g-pstyle5">20%</p>
    </div>
    <div id="g-ai0-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:58.5346%;width:42px;">
      <p class="g-pstyle5">20%</p>
    </div>
    <div id="g-ai0-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:63.5102%;width:42px;">
      <p class="g-pstyle5">20%</p>
    </div>
    <div id="g-ai0-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:87.2793%;width:33px;">
      <p class="g-pstyle6">71</p>
    </div>
    <div id="g-ai0-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:29.9525%;margin-top:-7.6px;left:93.1993%;width:81px;">
      <p class="g-pstyle11">$5.539.000</p>
    </div>
    <div id="g-ai0-115" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:32.936%;margin-top:-7.6px;left:1.8633%;width:111px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Au<span class="g-cstyle4">s</span>tral<span class="g-cstyle4"> </span>de Chi<span class="g-cstyle4">l</span>e<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:21.4654%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle18">V</span>aldiv<span class="g-cstyle4">i</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:30.3537%;width:59px;">
      <p class="g-pstyle6">75<span class="g-cstyle7">8</span>,4<span class="g-cstyle4">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:38.4094%;width:59px;">
      <p class="g-pstyle6">77<span class="g-cstyle5">0</span><span class="g-cstyle12">,</span><span class="g-cstyle4">0</span>9<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:46.4644%;width:59px;">
      <p class="g-pstyle6">79<span class="g-cstyle6">9</span><span class="g-cstyle19">,</span>90<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:63.5102%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">46<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.135%;margin-top:-7.6px;left:93.1993%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle11">.</span>618<span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-128" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:36.1185%;margin-top:-7.6px;left:1.8633%;width:106px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de La <span class="g-cstyle11">F</span><span class="g-cstyle15">r</span>o<span class="g-cstyle4">n</span>tera<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:21.2669%;width:61px;">
      <p class="g-pstyle5"><span class="g-cstyle20">T</span>emu<span class="g-cstyle4">co</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:30.4013%;width:57px;">
      <p class="g-pstyle6">756,<span class="g-cstyle4">1</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:38.4887%;width:58px;">
      <p class="g-pstyle6">76<span class="g-cstyle14">7</span>,<span class="g-cstyle4">5</span>3<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:46.4961%;width:58px;">
      <p class="g-pstyle6">81<span class="g-cstyle7">3</span><span class="g-cstyle9">,</span>05<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:87.3111%;width:37px;">
      <p class="g-pstyle6">56<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.1186%;margin-top:-7.6px;left:93.3025%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle9">.</span>78<span class="g-cstyle8">7</span><span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-141" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:39.1021%;margin-top:-7.6px;left:1.8633%;width:172px;">
      <p class="g-pstyle5">UC <span class="g-cstyle4">d</span>e<span class="g-cstyle4"> </span>la<span class="g-cstyle4"> </span>Sant<span class="g-cstyle4">í</span>sima C<span class="g-cstyle4">o</span>n<span class="g-cstyle4">c</span>epció<span class="g-cstyle4">n</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:20.2987%;width:79px;">
      <p class="g-pstyle8">Co<span class="g-cstyle13">n</span>ce<span class="g-cstyle13">p</span>ció<span class="g-cstyle13">n</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:73.5894%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:30.3617%;width:59px;">
      <p class="g-pstyle6">75<span class="g-cstyle4">5</span><span class="g-cstyle12">,</span>60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:38.4411%;width:59px;">
      <p class="g-pstyle6">76<span class="g-cstyle7">3</span>,<span class="g-cstyle4">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:46.5358%;width:57px;">
      <p class="g-pstyle6">7<span class="g-cstyle17">7</span><span class="g-cstyle12">4</span><span class="g-cstyle4">,</span>15<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:79.8425%;width:45px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.3011%;margin-top:-7.6px;left:93.1756%;width:83px;">
      <p class="g-pstyle12"><span class="g-cstyle4">$</span><span class="g-cstyle8">7</span>.<span class="g-cstyle13">9</span><span class="g-cstyle4">0</span>0.<span class="g-cstyle4">0</span><span class="g-cstyle13">00</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-154" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:42.0857%;margin-top:-7.6px;left:1.8633%;width:77px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de <span class="g-cstyle21">T</span>alca<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:22.0051%;width:49px;">
      <p class="g-pstyle5"><span class="g-cstyle22">T</span>al<span class="g-cstyle4">c</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:30.3301%;width:60px;">
      <p class="g-pstyle6">75<span class="g-cstyle12">4</span><span class="g-cstyle4">,</span>80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:38.4094%;width:59px;">
      <p class="g-pstyle6">766<span class="g-cstyle9">,</span>62<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:46.4803%;width:58px;">
      <p class="g-pstyle6">81<span class="g-cstyle4">2</span><span class="g-cstyle9">,</span>05<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:53.6777%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:63.5102%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:73.5894%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:79.8425%;width:45px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:87.3429%;width:36px;">
      <p class="g-pstyle6">75<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2847%;margin-top:-7.6px;left:93.0723%;width:84px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6<span class="g-cstyle4">.</span>344<span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-167" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:45.2682%;margin-top:-7.6px;left:1.8633%;width:124px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. C<span class="g-cstyle23">a</span>tólic<span class="g-cstyle4">a</span> del Maule<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:22.0051%;width:49px;">
      <p class="g-pstyle5"><span class="g-cstyle22">T</span>al<span class="g-cstyle4">c</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:30.3854%;width:58px;">
      <p class="g-pstyle6">752<span class="g-cstyle12">,</span>65<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:38.3933%;width:59px;">
      <p class="g-pstyle6">76<span class="g-cstyle4">2</span>,8<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:46.4246%;width:59px;">
      <p class="g-pstyle6">80<span class="g-cstyle9">4</span>,1<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:53.6777%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:63.5102%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:73.5579%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:87.3111%;width:37px;">
      <p class="g-pstyle6">70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.2683%;margin-top:-7.6px;left:93.1912%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6<span class="g-cstyle9">.</span>7<span class="g-cstyle4">6</span>3<span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-180" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:48.2518%;margin-top:-7.6px;left:1.8633%;width:91px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Fi<span class="g-cstyle4">n</span>is <span class="g-cstyle24">T</span>erra<span class="g-cstyle4">e</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:30.4093%;width:56px;">
      <p class="g-pstyle6">75<span class="g-cstyle4">1</span>,1<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:38.449%;width:58px;">
      <p class="g-pstyle6">75<span class="g-cstyle6">9</span><span class="g-cstyle4">,</span>8<span class="g-cstyle4">7</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:46.4803%;width:59px;">
      <p class="g-pstyle6">776<span class="g-cstyle4">,</span>2<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:63.4706%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:73.5579%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:79.8109%;width:46px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>0%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:87.3111%;width:37px;">
      <p class="g-pstyle6">70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.2519%;margin-top:-7.6px;left:93.1516%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8.<span class="g-cstyle4">5</span>5<span class="g-cstyle9">0</span><span class="g-cstyle11">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-193" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:51.2354%;margin-top:-7.6px;left:1.8633%;width:96px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de <span class="g-cstyle21">T</span>ara<span class="g-cstyle4">p</span>ac<span class="g-cstyle4">á</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:22.0369%;width:48px;">
      <p class="g-pstyle5">Ar<span class="g-cstyle4">ic</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:30.3061%;width:60px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>46<span class="g-cstyle12">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:38.3933%;width:60px;">
      <p class="g-pstyle6">75<span class="g-cstyle7">8</span><span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:46.4407%;width:60px;">
      <p class="g-pstyle6">79<span class="g-cstyle7">8</span><span class="g-cstyle12">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:53.6777%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:79.7871%;width:47px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:87.2952%;width:38px;">
      <p class="g-pstyle6">30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4343%;margin-top:-7.6px;left:93.2071%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>595<span class="g-cstyle11">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-206" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:1.8633%;width:122px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. C<span class="g-cstyle23">a</span>tólic<span class="g-cstyle4">a</span> del Norte<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:20.6718%;width:72px;">
      <p class="g-pstyle5"><span class="g-cstyle4">Co</span>qui<span class="g-cstyle4">m</span>b<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:30.314%;width:60px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>4<span class="g-cstyle5">0</span><span class="g-cstyle4">,</span>2<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:38.4013%;width:59px;">
      <p class="g-pstyle6">75<span class="g-cstyle9">4</span>,<span class="g-cstyle4">2</span>4<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:46.4485%;width:59px;">
      <p class="g-pstyle6">78<span class="g-cstyle4">6</span><span class="g-cstyle25">,</span><span class="g-cstyle4">9</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">48<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.4179%;margin-top:-7.6px;left:93.0882%;width:84px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>80<span class="g-cstyle9">0</span><span class="g-cstyle11">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-219" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:1.8633%;width:104px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Sa<span class="g-cstyle4">n</span> S<span class="g-cstyle4">e</span>b<span class="g-cstyle4">a</span>stián<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:20.2987%;width:79px;">
      <p class="g-pstyle8">Co<span class="g-cstyle13">n</span>ce<span class="g-cstyle13">p</span>ció<span class="g-cstyle13">n</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:30.3854%;width:59px;">
      <p class="g-pstyle6">73<span class="g-cstyle14">7</span><span class="g-cstyle12">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:38.4251%;width:59px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>4<span class="g-cstyle14">7</span><span class="g-cstyle9">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:46.4246%;width:60px;">
      <p class="g-pstyle6">79<span class="g-cstyle12">4</span><span class="g-cstyle9">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:87.0334%;width:41px;">
      <p class="g-pstyle6">11<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4015%;margin-top:-7.6px;left:93.1357%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8.<span class="g-cstyle4">1</span>4<span class="g-cstyle9">0.</span>9<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-232" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:60.3851%;margin-top:-7.6px;left:1.8633%;width:72px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Ma<span class="g-cstyle4">y</span>or*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:30.338%;width:60px;">
      <p class="g-pstyle6">736<span class="g-cstyle4">,8</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:38.4807%;width:58px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>4<span class="g-cstyle14">7</span><span class="g-cstyle4">,</span>33<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:46.52%;width:57px;">
      <p class="g-pstyle6">77<span class="g-cstyle6">9</span>,1<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">5<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:68.3761%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:79.8346%;width:45px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.584%;margin-top:-7.6px;left:93.3103%;width:80px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span><span class="g-cstyle8">7</span><span class="g-cstyle9">.</span>9<span class="g-cstyle4">0</span><span class="g-cstyle16">9</span><span class="g-cstyle4">.</span>160<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-245" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:63.3687%;margin-top:-7.6px;left:1.8633%;width:106px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Di<span class="g-cstyle4">eg</span>o<span class="g-cstyle4"> </span>P<span class="g-cstyle4">o</span>rtale<span class="g-cstyle4">s</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:53.6381%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:58.5187%;width:45px;">
      <p class="g-pstyle5">40%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:30.3301%;width:60px;">
      <p class="g-pstyle6">736<span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:38.4966%;width:57px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>4<span class="g-cstyle14">7</span><span class="g-cstyle17">,</span>73<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:46.4644%;width:59px;">
      <p class="g-pstyle6">76<span class="g-cstyle7">8</span>,5<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:79.8346%;width:45px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:87.3111%;width:37px;">
      <p class="g-pstyle6">70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.5676%;margin-top:-7.6px;left:93.12%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8<span class="g-cstyle9">.</span>70<span class="g-cstyle4">8</span><span class="g-cstyle9">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-258" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:1.8633%;width:96px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. An<span class="g-cstyle4">d</span><span class="g-cstyle15">r</span>és <span class="g-cstyle4">B</span>ello<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:30.3776%;width:58px;">
      <p class="g-pstyle6">72<span class="g-cstyle14">7</span><span class="g-cstyle12">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:38.3933%;width:60px;">
      <p class="g-pstyle6">756<span class="g-cstyle9">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:46.4724%;width:59px;">
      <p class="g-pstyle6">77<span class="g-cstyle6">9</span><span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:63.4706%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:87.2952%;width:37px;">
      <p class="g-pstyle6">96<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.5512%;margin-top:-7.6px;left:93.2071%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8<span class="g-cstyle9">.</span>96<span class="g-cstyle26">7</span><span class="g-cstyle9">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-271" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:69.5347%;margin-top:-7.6px;left:1.8633%;width:128px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Be<span class="g-cstyle4">r</span>nard<span class="g-cstyle4">o</span> O&rsquo;Higgins<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:21.1797%;width:65px;">
      <p class="g-pstyle5"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:30.3617%;width:59px;">
      <p class="g-pstyle6">726<span class="g-cstyle4">,</span>8<span class="g-cstyle4">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:38.3933%;width:59px;">
      <p class="g-pstyle6">73<span class="g-cstyle9">4</span><span class="g-cstyle12">,</span>6<span class="g-cstyle4">4</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:46.4803%;width:59px;">
      <p class="g-pstyle6">75<span class="g-cstyle4">2</span><span class="g-cstyle25">,</span>9<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:53.6777%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:63.4706%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.7337%;margin-top:-7.6px;left:93.2152%;width:80px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8.<span class="g-cstyle4">1</span>1<span class="g-cstyle9">0</span><span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-284" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:72.5183%;margin-top:-7.6px;left:1.8633%;width:97px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de O&rsquo;H<span class="g-cstyle4">i</span>ggins<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:20.8782%;width:70px;">
      <p class="g-pstyle5">Ran<span class="g-cstyle4">ca</span>gua<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:30.3301%;width:59px;">
      <p class="g-pstyle6">726<span class="g-cstyle4">,</span>80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:38.3933%;width:59px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>4<span class="g-cstyle4">2</span><span class="g-cstyle12">,</span>6<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:46.3931%;width:61px;">
      <p class="g-pstyle6">80<span class="g-cstyle9">4</span>,8<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-295" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:87.2793%;width:38px;">
      <p class="g-pstyle6">80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-296" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7173%;margin-top:-7.6px;left:93.1516%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>39<span class="g-cstyle9">0</span><span class="g-cstyle11">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-297" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:75.7008%;margin-top:-7.6px;left:1.8633%;width:110px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de Ma<span class="g-cstyle4">g</span>a<span class="g-cstyle4">l</span>la<span class="g-cstyle4">n</span>es*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-298" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:20.14%;width:86px;">
      <p class="g-pstyle5">Punta<span class="g-cstyle4"> </span>A<span class="g-cstyle12">r</span><span class="g-cstyle4">e</span>nas<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-299" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:30.3696%;width:57px;">
      <p class="g-pstyle6">721<span class="g-cstyle12">,</span>6<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-300" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:39.4966%;width:36px;">
      <p class="g-pstyle6">s/<span class="g-cstyle4">i</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-301" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:46.5041%;width:59px;">
      <p class="g-pstyle6">79<span class="g-cstyle7">3</span>,<span class="g-cstyle4">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-302" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:53.7096%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-303" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:58.5665%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-304" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:63.5102%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-305" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:68.4157%;width:43px;">
      <p class="g-pstyle5">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-306" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:73.5579%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-307" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:79.8425%;width:45px;">
      <p class="g-pstyle6"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-308" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:87.3033%;width:38px;">
      <p class="g-pstyle11"><span class="g-cstyle13">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-309" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.7009%;margin-top:-7.6px;left:93.1834%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle11">.</span>091<span class="g-cstyle11">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-310" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:78.6844%;margin-top:-7.6px;left:1.8633%;width:132px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Aut<span class="g-cstyle4">ó</span>n<span class="g-cstyle4">o</span>m<span class="g-cstyle4">a</span> de Ch<span class="g-cstyle4">i</span>le*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-311" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:22.0051%;width:49px;">
      <p class="g-pstyle5"><span class="g-cstyle22">T</span>al<span class="g-cstyle4">c</span>a<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-312" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:38.4171%;width:58px;">
      <p class="g-pstyle6">72<span class="g-cstyle9">4</span><span class="g-cstyle17">,</span>70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-313" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-314" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-315" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-316" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:68.3761%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-317" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-318" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:79.8187%;width:46px;">
      <p class="g-pstyle6">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-319" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:87.3033%;width:38px;">
      <p class="g-pstyle11"><span class="g-cstyle13">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-320" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:30.3458%;width:58px;">
      <p class="g-pstyle6">71<span class="g-cstyle12">4</span><span class="g-cstyle4">,</span>8<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-321" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:46.4485%;width:60px;">
      <p class="g-pstyle6">76<span class="g-cstyle5">0</span>,<span class="g-cstyle4">2</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-322" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.8834%;margin-top:-7.6px;left:93.1516%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span><span class="g-cstyle8">7</span><span class="g-cstyle4">.</span>448<span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-323" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:81.668%;margin-top:-7.6px;left:1.8633%;width:109px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de An<span class="g-cstyle4">t</span><span class="g-cstyle23">o</span>faga<span class="g-cstyle4">s</span>ta<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-324" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:20.4336%;width:80px;">
      <p class="g-pstyle5">Ant<span class="g-cstyle15">o</span>fa<span class="g-cstyle4">g</span>a<span class="g-cstyle4">s</span>ta<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-325" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:30.3458%;width:58px;">
      <p class="g-pstyle6">671<span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-326" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:38.4171%;width:60px;">
      <p class="g-pstyle6">75<span class="g-cstyle7">3</span><span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-327" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:46.4724%;width:58px;">
      <p class="g-pstyle6">781<span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-328" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:53.63%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-329" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-330" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:63.4784%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-331" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-332" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-333" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:79.7871%;width:47px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-334" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:87.327%;width:37px;">
      <p class="g-pstyle6">35<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-335" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.867%;margin-top:-7.6px;left:93.2389%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle9">.</span>7<span class="g-cstyle17">7</span>4<span class="g-cstyle11">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-336" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:84.8505%;margin-top:-7.6px;left:1.8633%;width:94px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de <span class="g-cstyle15">A</span>tac<span class="g-cstyle4">a</span>ma<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-337" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:21.1878%;width:63px;">
      <p class="g-pstyle5"><span class="g-cstyle4">Co</span>piap<span class="g-cstyle4">ó</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-338" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:30.314%;width:60px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">4</span><span class="g-cstyle7">3</span><span class="g-cstyle4">,</span>30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-339" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:38.425%;width:59px;">
      <p class="g-pstyle6"><span class="g-cstyle17">7</span>4<span class="g-cstyle5">0</span>,37<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-340" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:46.4565%;width:59px;">
      <p class="g-pstyle6">77<span class="g-cstyle4">6</span>,<span class="g-cstyle4">4</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-341" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:53.6777%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-342" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:58.5346%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-343" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:63.4307%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-344" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:69.368%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-345" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:73.5975%;width:43px;">
      <p class="g-pstyle5">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-346" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:79.7871%;width:47px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-347" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:87.2952%;width:37px;">
      <p class="g-pstyle6">45<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-348" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.8506%;margin-top:-7.6px;left:93.2071%;width:80px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>3<span class="g-cstyle4">2</span>2<span class="g-cstyle11">.</span>00<span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai0-349" class="g-Layer_1 g-aiAbs" style="top:90.3033%;left:0.7447%;width:97.9787%;">
      <p class="g-pstyle13">Fuente: Información proporcionada por cada casa de estudio, la cual corresponde a la jornada diurna / En algunos casos los aranceles y vacantes corresponden al año 2021 / (*) Piden una de las dos pruebas optativas / La información de las universidades de Magallanes y de Santiago de Chile fue extraída de sus portales &mdash;www.umag.cl y www.usach.cl&mdash;. Mientras en la primera el puntaje de corte corresponde al último matriculado, en la segunda se explica que es del último seleccionado. Asimismo, los aranceles de la USACh corresponden a los deciles 7, 8 y 9.</p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-medicina-mobile" class="g-artboard" style="max-width: 320px;max-height: 1474px" data-aspect-ratio="0.217" data-min-width="0" data-max-width="939">
<div style="padding: 0 0 460.625% 0;"></div>
    <img id="g-medicina-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:1.8051%;margin-top:-12.6px;left:73.2382%;width:47px;">
      <p class="g-pstyle0">Prom </p>
      <p class="g-pstyle0">P<span class="g-cstyle0">o</span>n<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:1.873%;margin-top:-12.6px;left:87.8571%;width:45px;">
      <p class="g-pstyle0"><span class="g-cstyle0">M</span>áx </p>
      <p class="g-pstyle0">Po<span class="g-cstyle0">n</span><span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-3" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:2.1309%;margin-top:-8.4px;left:2.6447%;width:91px;">
      <p class="g-pstyle1">Univ<span class="g-cstyle0">e</span>r<span class="g-cstyle0">s</span>ida<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.1549%;margin-top:-6.8px;left:42.8748%;width:45px;">
      <p class="g-pstyle0">Sed<span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai1-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.1549%;margin-top:-6.8px;left:56.4859%;width:63px;">
      <p class="g-pstyle0">M<span class="g-cstyle2">í</span>n <span class="g-cstyle0">P</span>o<span class="g-cstyle0">n</span><span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-6" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:3.9746%;margin-top:-7.6px;left:2.5046%;width:87px;">
      <p class="g-pstyle2">PUC de<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.9746%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.9746%;margin-top:-7.6px;left:58.024%;width:59px;">
      <p class="g-pstyle3">8<span class="g-cstyle3">0</span><span class="g-cstyle4">0</span>,1<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.9746%;margin-top:-7.6px;left:72.1487%;width:61px;">
      <p class="g-pstyle3">80<span class="g-cstyle5">9</span>,40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:3.9746%;margin-top:-7.6px;left:86.669%;width:60px;">
      <p class="g-pstyle3">83<span class="g-cstyle6">3</span>,30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:4.9923%;margin-top:-7.6px;left:2.5046%;width:134px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de San<span class="g-cstyle3">ti</span>ago de Chile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0601%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0601%;margin-top:-7.6px;left:58.1635%;width:57px;">
      <p class="g-pstyle3">79<span class="g-cstyle6">8</span><span class="g-cstyle3">,</span>15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0601%;margin-top:-7.6px;left:75.5524%;width:36px;">
      <p class="g-pstyle3">s/<span class="g-cstyle3">i</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0601%;margin-top:-7.6px;left:86.7621%;width:58px;">
      <p class="g-pstyle3">781<span class="g-cstyle8">,</span>05<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:6.0099%;margin-top:-7.6px;left:2.5046%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.0777%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.0777%;margin-top:-7.6px;left:58.024%;width:59px;">
      <p class="g-pstyle3">77<span class="g-cstyle6">8</span><span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.0777%;margin-top:-7.6px;left:72.3123%;width:60px;">
      <p class="g-pstyle3">79<span class="g-cstyle4">0</span>,5<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.0777%;margin-top:-7.6px;left:86.5988%;width:58px;">
      <p class="g-pstyle3">84<span class="g-cstyle3">2</span>,<span class="g-cstyle3">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:7.0954%;margin-top:-7.6px;left:2.5046%;width:98px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de los <span class="g-cstyle3">A</span>ndes<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0954%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0954%;margin-top:-7.6px;left:58.1406%;width:58px;">
      <p class="g-pstyle3">77<span class="g-cstyle3">2</span>,5<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0954%;margin-top:-7.6px;left:72.265%;width:60px;">
      <p class="g-pstyle3">78<span class="g-cstyle9">4</span><span class="g-cstyle8">,</span>06<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0954%;margin-top:-7.6px;left:86.669%;width:60px;">
      <p class="g-pstyle3">83<span class="g-cstyle6">3</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:8.113%;margin-top:-7.6px;left:2.5046%;width:108px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de C<span class="g-cstyle3">o</span>ncepción<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.113%;margin-top:-7.6px;left:37.9086%;width:79px;">
      <p class="g-pstyle4">Co<span class="g-cstyle10">n</span>ce<span class="g-cstyle10">p</span>ció<span class="g-cstyle10">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.113%;margin-top:-7.6px;left:58.0704%;width:58px;">
      <p class="g-pstyle3">766,<span class="g-cstyle3">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.113%;margin-top:-7.6px;left:72.2421%;width:60px;">
      <p class="g-pstyle3">78<span class="g-cstyle4">0</span>,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.113%;margin-top:-7.6px;left:86.7621%;width:58px;">
      <p class="g-pstyle3">8<span class="g-cstyle3">2</span><span class="g-cstyle11">7</span>,4<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:9.1307%;margin-top:-7.6px;left:2.5046%;width:102px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de<span class="g-cstyle3">l</span> De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle12">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.1985%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.1985%;margin-top:-7.6px;left:58.0472%;width:59px;">
      <p class="g-pstyle3">76<span class="g-cstyle9">4</span><span class="g-cstyle13">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.1985%;margin-top:-7.6px;left:72.4988%;width:58px;">
      <p class="g-pstyle3">772<span class="g-cstyle14">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.1985%;margin-top:-7.6px;left:86.5759%;width:60px;">
      <p class="g-pstyle3">79<span class="g-cstyle5">9</span>,<span class="g-cstyle3">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:10.1483%;margin-top:-7.6px;left:2.5046%;width:98px;">
      <p class="g-pstyle4">U. de Valparaíso</p>
    </div>
    <div id="g-ai1-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.2162%;margin-top:-7.6px;left:41.3358%;width:60px;">
      <p class="g-pstyle2"><span class="g-cstyle15">V</span>aldiv<span class="g-cstyle3">i</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.2162%;margin-top:-7.6px;left:58.0704%;width:59px;">
      <p class="g-pstyle3">75<span class="g-cstyle6">8</span>,4<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.2162%;margin-top:-7.6px;left:72.359%;width:54px;">
      <p class="g-pstyle3">772.10</p>
    </div>
    <div id="g-ai1-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.2162%;margin-top:-7.6px;left:86.6455%;width:56px;">
      <p class="g-pstyle3">813.40</p>
    </div>
    <div id="g-ai1-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2338%;margin-top:-7.6px;left:39.4608%;width:67px;">
      <p class="g-pstyle5">Valparaíso</p>
    </div>
    <div id="g-ai1-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2338%;margin-top:-7.6px;left:58.0704%;width:57px;">
      <p class="g-pstyle3">762.40</p>
    </div>
    <div id="g-ai1-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2338%;margin-top:-7.6px;left:72.359%;width:59px;">
      <p class="g-pstyle3">77<span class="g-cstyle4">0</span><span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.2338%;margin-top:-7.6px;left:86.6455%;width:59px;">
      <p class="g-pstyle3">79<span class="g-cstyle5">9</span><span class="g-cstyle16">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:11.2338%;margin-top:-7.6px;left:2.5046%;width:111px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle3">s</span>tral<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.2514%;margin-top:-7.6px;left:40.7529%;width:61px;">
      <p class="g-pstyle2"><span class="g-cstyle17">T</span>emu<span class="g-cstyle3">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.2514%;margin-top:-7.6px;left:58.2101%;width:57px;">
      <p class="g-pstyle3">756,<span class="g-cstyle3">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.2514%;margin-top:-7.6px;left:72.5919%;width:58px;">
      <p class="g-pstyle3">76<span class="g-cstyle11">7</span>,<span class="g-cstyle3">5</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.2514%;margin-top:-7.6px;left:86.7386%;width:58px;">
      <p class="g-pstyle3">81<span class="g-cstyle6">3</span><span class="g-cstyle8">,</span>05<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-50" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:12.3193%;margin-top:-7.6px;left:2.5046%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de La <span class="g-cstyle18">F</span><span class="g-cstyle12">r</span>o<span class="g-cstyle3">n</span>tera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.3369%;margin-top:-7.6px;left:37.9086%;width:79px;">
      <p class="g-pstyle4">Co<span class="g-cstyle10">n</span>ce<span class="g-cstyle10">p</span>ció<span class="g-cstyle10">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.3369%;margin-top:-7.6px;left:58.0939%;width:59px;">
      <p class="g-pstyle3">75<span class="g-cstyle3">5</span><span class="g-cstyle9">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.3369%;margin-top:-7.6px;left:72.4521%;width:59px;">
      <p class="g-pstyle3">76<span class="g-cstyle6">3</span>,<span class="g-cstyle3">2</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.3369%;margin-top:-7.6px;left:86.8552%;width:57px;">
      <p class="g-pstyle3">7<span class="g-cstyle14">7</span><span class="g-cstyle9">4</span><span class="g-cstyle3">,</span>15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:13.3369%;margin-top:-7.6px;left:2.5046%;width:136px;">
      <p class="g-pstyle2">UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>la<span class="g-cstyle3"> </span>S. C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epció<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.3546%;margin-top:-7.6px;left:42.9211%;width:49px;">
      <p class="g-pstyle2"><span class="g-cstyle19">T</span>al<span class="g-cstyle3">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.3546%;margin-top:-7.6px;left:58.0008%;width:60px;">
      <p class="g-pstyle3">75<span class="g-cstyle9">4</span><span class="g-cstyle3">,</span>80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.3546%;margin-top:-7.6px;left:72.359%;width:59px;">
      <p class="g-pstyle3">766<span class="g-cstyle8">,</span>62<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.3546%;margin-top:-7.6px;left:86.6922%;width:58px;">
      <p class="g-pstyle3">81<span class="g-cstyle3">2</span><span class="g-cstyle8">,</span>05<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:14.3545%;margin-top:-7.6px;left:2.5046%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle20">T</span>alca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3722%;margin-top:-7.6px;left:42.9211%;width:49px;">
      <p class="g-pstyle2"><span class="g-cstyle19">T</span>al<span class="g-cstyle3">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3722%;margin-top:-7.6px;left:58.1635%;width:58px;">
      <p class="g-pstyle3">752<span class="g-cstyle9">,</span>65<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3722%;margin-top:-7.6px;left:72.3117%;width:59px;">
      <p class="g-pstyle3">76<span class="g-cstyle3">2</span>,8<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3722%;margin-top:-7.6px;left:86.5286%;width:59px;">
      <p class="g-pstyle3">80<span class="g-cstyle8">4</span>,1<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:15.44%;margin-top:-7.6px;left:2.5046%;width:124px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Maule<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.4577%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.4577%;margin-top:-7.6px;left:58.2336%;width:56px;">
      <p class="g-pstyle3">75<span class="g-cstyle3">1</span>,1<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.4577%;margin-top:-7.6px;left:72.4753%;width:58px;">
      <p class="g-pstyle3">75<span class="g-cstyle5">9</span><span class="g-cstyle3">,</span>8<span class="g-cstyle3">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.4577%;margin-top:-7.6px;left:86.6922%;width:59px;">
      <p class="g-pstyle3">776<span class="g-cstyle3">,</span>2<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:16.4577%;margin-top:-7.6px;left:2.5046%;width:91px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Fi<span class="g-cstyle3">n</span>is <span class="g-cstyle22">T</span>erra<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.4753%;margin-top:-7.6px;left:43.0145%;width:48px;">
      <p class="g-pstyle2">Ar<span class="g-cstyle3">ic</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.4753%;margin-top:-7.6px;left:57.9303%;width:60px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>46<span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.4753%;margin-top:-7.6px;left:72.3117%;width:60px;">
      <p class="g-pstyle3">75<span class="g-cstyle6">8</span><span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.4753%;margin-top:-7.6px;left:86.5759%;width:60px;">
      <p class="g-pstyle3">79<span class="g-cstyle6">8</span><span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:17.4753%;margin-top:-7.6px;left:2.5046%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle20">T</span>ara<span class="g-cstyle3">p</span>ac<span class="g-cstyle3">á</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.493%;margin-top:-7.6px;left:39.0045%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle3">Co</span>qui<span class="g-cstyle3">m</span>b<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.493%;margin-top:-7.6px;left:57.9535%;width:60px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>4<span class="g-cstyle4">0</span><span class="g-cstyle3">,</span>2<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.493%;margin-top:-7.6px;left:72.3352%;width:59px;">
      <p class="g-pstyle3">75<span class="g-cstyle8">4</span>,<span class="g-cstyle3">2</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.493%;margin-top:-7.6px;left:86.5988%;width:59px;">
      <p class="g-pstyle3">78<span class="g-cstyle3">6</span><span class="g-cstyle23">,</span><span class="g-cstyle3">9</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-80" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:18.5608%;margin-top:-7.6px;left:2.5046%;width:122px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Norte<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5785%;margin-top:-7.6px;left:37.9086%;width:79px;">
      <p class="g-pstyle4">Co<span class="g-cstyle10">n</span>ce<span class="g-cstyle10">p</span>ció<span class="g-cstyle10">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5785%;margin-top:-7.6px;left:58.1635%;width:59px;">
      <p class="g-pstyle3">73<span class="g-cstyle11">7</span><span class="g-cstyle9">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5785%;margin-top:-7.6px;left:72.4051%;width:59px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>4<span class="g-cstyle11">7</span><span class="g-cstyle8">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5785%;margin-top:-7.6px;left:86.5286%;width:60px;">
      <p class="g-pstyle3">79<span class="g-cstyle9">4</span><span class="g-cstyle8">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:19.5784%;margin-top:-7.6px;left:2.5046%;width:104px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Sa<span class="g-cstyle3">n</span> S<span class="g-cstyle3">e</span>b<span class="g-cstyle3">a</span>stián<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.5961%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.5961%;margin-top:-7.6px;left:58.024%;width:60px;">
      <p class="g-pstyle3">736<span class="g-cstyle3">,8</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.5961%;margin-top:-7.6px;left:72.5684%;width:58px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>4<span class="g-cstyle11">7</span><span class="g-cstyle3">,</span>33<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.5961%;margin-top:-7.6px;left:86.8088%;width:57px;">
      <p class="g-pstyle3">77<span class="g-cstyle5">9</span>,1<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-90" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:20.5961%;margin-top:-7.6px;left:2.5046%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Ma<span class="g-cstyle3">y</span>or*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6137%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6137%;margin-top:-7.6px;left:58.0008%;width:60px;">
      <p class="g-pstyle3">736<span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6137%;margin-top:-7.6px;left:72.6151%;width:57px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>4<span class="g-cstyle11">7</span><span class="g-cstyle14">,</span>73<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.6137%;margin-top:-7.6px;left:86.6455%;width:59px;">
      <p class="g-pstyle3">76<span class="g-cstyle6">8</span>,5<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-95" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:21.6815%;margin-top:-7.6px;left:2.5046%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Di<span class="g-cstyle3">eg</span>o<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>rtale<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.6313%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.6313%;margin-top:-7.6px;left:58.1406%;width:58px;">
      <p class="g-pstyle3">72<span class="g-cstyle11">7</span><span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.6313%;margin-top:-7.6px;left:72.3117%;width:60px;">
      <p class="g-pstyle3">756<span class="g-cstyle8">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.6313%;margin-top:-7.6px;left:86.669%;width:59px;">
      <p class="g-pstyle3">77<span class="g-cstyle5">9</span><span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-100" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:22.6992%;margin-top:-7.6px;left:2.5046%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. An<span class="g-cstyle3">d</span><span class="g-cstyle12">r</span>és <span class="g-cstyle3">B</span>ello<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7169%;margin-top:-7.6px;left:40.4965%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7169%;margin-top:-7.6px;left:58.0939%;width:59px;">
      <p class="g-pstyle3">726<span class="g-cstyle3">,</span>8<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7169%;margin-top:-7.6px;left:72.3117%;width:59px;">
      <p class="g-pstyle3">73<span class="g-cstyle8">4</span><span class="g-cstyle9">,</span>6<span class="g-cstyle3">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.7169%;margin-top:-7.6px;left:86.6922%;width:59px;">
      <p class="g-pstyle3">75<span class="g-cstyle3">2</span><span class="g-cstyle23">,</span>9<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-105" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:23.7168%;margin-top:-7.6px;left:2.5046%;width:128px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Be<span class="g-cstyle3">r</span>nard<span class="g-cstyle3">o</span> O&rsquo;Higgins<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.7345%;margin-top:-7.6px;left:39.6109%;width:70px;">
      <p class="g-pstyle2">Ran<span class="g-cstyle3">ca</span>gua<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.7345%;margin-top:-7.6px;left:58.0008%;width:59px;">
      <p class="g-pstyle3">726<span class="g-cstyle3">,</span>80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.7345%;margin-top:-7.6px;left:72.3117%;width:59px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>4<span class="g-cstyle3">2</span><span class="g-cstyle9">,</span>6<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.7345%;margin-top:-7.6px;left:86.4359%;width:61px;">
      <p class="g-pstyle3">80<span class="g-cstyle8">4</span>,8<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-110" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:24.7345%;margin-top:-7.6px;left:2.5046%;width:97px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de O&rsquo;H<span class="g-cstyle3">i</span>ggins<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.7521%;margin-top:-7.6px;left:37.4426%;width:86px;">
      <p class="g-pstyle2">Punta<span class="g-cstyle3"> </span>A<span class="g-cstyle9">r</span><span class="g-cstyle3">e</span>nas<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.7521%;margin-top:-7.6px;left:58.1171%;width:57px;">
      <p class="g-pstyle3">721<span class="g-cstyle9">,</span>6<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.7521%;margin-top:-7.6px;left:75.5524%;width:36px;">
      <p class="g-pstyle3">s/<span class="g-cstyle3">i</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.7521%;margin-top:-7.6px;left:86.7621%;width:59px;">
      <p class="g-pstyle3">79<span class="g-cstyle6">3</span>,<span class="g-cstyle3">2</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-115" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:25.8199%;margin-top:-7.6px;left:2.5046%;width:110px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de Ma<span class="g-cstyle3">g</span>a<span class="g-cstyle3">l</span>la<span class="g-cstyle3">n</span>es*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8376%;margin-top:-7.6px;left:42.9211%;width:49px;">
      <p class="g-pstyle2"><span class="g-cstyle19">T</span>al<span class="g-cstyle3">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8376%;margin-top:-7.6px;left:72.3816%;width:58px;">
      <p class="g-pstyle3">72<span class="g-cstyle8">4</span><span class="g-cstyle14">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8376%;margin-top:-7.6px;left:58.0472%;width:58px;">
      <p class="g-pstyle3">71<span class="g-cstyle9">4</span><span class="g-cstyle3">,</span>8<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8376%;margin-top:-7.6px;left:86.5988%;width:60px;">
      <p class="g-pstyle3">76<span class="g-cstyle4">0</span>,<span class="g-cstyle3">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-120" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:26.8376%;margin-top:-7.6px;left:2.5046%;width:132px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> de Ch<span class="g-cstyle3">i</span>le*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8553%;margin-top:-7.6px;left:38.3051%;width:80px;">
      <p class="g-pstyle2">Ant<span class="g-cstyle12">o</span>fa<span class="g-cstyle3">g</span>a<span class="g-cstyle3">s</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8553%;margin-top:-7.6px;left:58.0472%;width:58px;">
      <p class="g-pstyle3">671<span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8553%;margin-top:-7.6px;left:72.3816%;width:60px;">
      <p class="g-pstyle3">75<span class="g-cstyle6">3</span><span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.8553%;margin-top:-7.6px;left:86.669%;width:58px;">
      <p class="g-pstyle3">781<span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-125" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:27.8552%;margin-top:-7.6px;left:2.5046%;width:109px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de An<span class="g-cstyle3">t</span><span class="g-cstyle21">o</span>faga<span class="g-cstyle3">s</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.8729%;margin-top:-7.6px;left:40.5203%;width:63px;">
      <p class="g-pstyle2"><span class="g-cstyle3">Co</span>piap<span class="g-cstyle3">ó</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.8729%;margin-top:-7.6px;left:57.9535%;width:60px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">4</span><span class="g-cstyle6">3</span><span class="g-cstyle3">,</span>30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.8729%;margin-top:-7.6px;left:72.4048%;width:59px;">
      <p class="g-pstyle3"><span class="g-cstyle14">7</span>4<span class="g-cstyle4">0</span>,37<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.8729%;margin-top:-7.6px;left:86.6223%;width:59px;">
      <p class="g-pstyle3">77<span class="g-cstyle3">6</span>,<span class="g-cstyle3">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-130" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:28.9407%;margin-top:-7.6px;left:2.5046%;width:94px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle12">A</span>tac<span class="g-cstyle3">a</span>ma<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:44.0134%;width:40px;">
      <p class="g-pstyle6">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:49.8642%;width:24px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai1-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:53.0847%;width:40px;">
      <p class="g-pstyle6">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:58.9362%;width:24px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai1-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:62.4936%;width:40px;">
      <p class="g-pstyle6">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:68.3444%;width:24px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai1-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:74.0646%;width:40px;">
      <p class="g-pstyle6">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:79.9158%;width:24px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai1-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.8876%;margin-top:-6.8px;left:88.728%;width:44px;">
      <p class="g-pstyle0"> NE<span class="g-cstyle1">M</span></p>
    </div>
    <div id="g-ai1-140" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:33.6098%;margin-top:-8.4px;left:2.6447%;width:91px;">
      <p class="g-pstyle1">Univ<span class="g-cstyle0">e</span>r<span class="g-cstyle0">s</span>ida<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.6339%;margin-top:-6.8px;left:43.8733%;width:41px;">
      <p class="g-pstyle0">len<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai1-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.6339%;margin-top:-6.8px;left:53.2248%;width:39px;">
      <p class="g-pstyle8"><span class="g-cstyle24">m</span>a<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai1-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.6339%;margin-top:-6.8px;left:62.5165%;width:41px;">
      <p class="g-pstyle0">cie<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.6339%;margin-top:-6.8px;left:74.4141%;width:39px;">
      <p class="g-pstyle0">his<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai1-145" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:35.4536%;margin-top:-7.6px;left:2.5046%;width:87px;">
      <p class="g-pstyle2">PUC de<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4536%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4536%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4536%;margin-top:-7.6px;left:62.5388%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4536%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.4536%;margin-top:-7.6px;left:89.3576%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-151" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:36.4712%;margin-top:-7.6px;left:2.5046%;width:134px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de San<span class="g-cstyle3">ti</span>ago de Chile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.5391%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.5391%;margin-top:-7.6px;left:53.2721%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.5391%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.5391%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.5391%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-157" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:37.4889%;margin-top:-7.6px;left:2.5046%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5567%;margin-top:-7.6px;left:44.0845%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5567%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5567%;margin-top:-7.6px;left:62.4454%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5567%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5567%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-163" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:38.5744%;margin-top:-7.6px;left:2.5046%;width:98px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de los <span class="g-cstyle3">A</span>ndes<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.5744%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.5744%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.5744%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.5744%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.5744%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-169" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:39.592%;margin-top:-7.6px;left:2.5046%;width:108px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de C<span class="g-cstyle3">o</span>ncepción<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.592%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.592%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.592%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.592%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.592%;margin-top:-7.6px;left:89.5901%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-175" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:40.6096%;margin-top:-7.6px;left:2.5046%;width:102px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de<span class="g-cstyle3">l</span> De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle12">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.6775%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.6775%;margin-top:-7.6px;left:52.9926%;width:45px;">
      <p class="g-pstyle2">40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.6775%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.6775%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.6775%;margin-top:-7.6px;left:89.5901%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-181" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:41.6273%;margin-top:-7.6px;left:2.5046%;width:98px;">
      <p class="g-pstyle4">U. de Valparaíso</p>
    </div>
    <div id="g-ai1-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.6951%;margin-top:-7.6px;left:44.1782%;width:42px;">
      <p class="g-pstyle2">20%</p>
    </div>
    <div id="g-ai1-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.6951%;margin-top:-7.6px;left:53.0392%;width:42px;">
      <p class="g-pstyle2">20%</p>
    </div>
    <div id="g-ai1-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.6951%;margin-top:-7.6px;left:62.655%;width:42px;">
      <p class="g-pstyle2">20%</p>
    </div>
    <div id="g-ai1-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.6951%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.6951%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-7.6px;left:62.655%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-192" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-7.6px;left:2.5046%;width:111px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle3">s</span>tral<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-193" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:43.7982%;margin-top:-7.6px;left:2.5046%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de La <span class="g-cstyle18">F</span><span class="g-cstyle12">r</span>o<span class="g-cstyle3">n</span>tera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7982%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7982%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7982%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7982%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7982%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-199" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:44.8159%;margin-top:-7.6px;left:2.5046%;width:136px;">
      <p class="g-pstyle2">UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>la<span class="g-cstyle3"> </span>S. C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epció<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8837%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8837%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8837%;margin-top:-7.6px;left:89.4501%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8837%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8837%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-205" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:45.8335%;margin-top:-7.6px;left:2.5046%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle20">T</span>alca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.9014%;margin-top:-7.6px;left:44.0845%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.9014%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.9014%;margin-top:-7.6px;left:62.655%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.9014%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.9014%;margin-top:-7.6px;left:89.4501%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-211" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:46.919%;margin-top:-7.6px;left:2.5046%;width:124px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Maule<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.919%;margin-top:-7.6px;left:44.0845%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.919%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.919%;margin-top:-7.6px;left:62.655%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.919%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.919%;margin-top:-7.6px;left:89.3576%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-217" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:47.9366%;margin-top:-7.6px;left:2.5046%;width:91px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Fi<span class="g-cstyle3">n</span>is <span class="g-cstyle22">T</span>erra<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.0045%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.0045%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.0045%;margin-top:-7.6px;left:62.5388%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.0045%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.0045%;margin-top:-7.6px;left:89.3576%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-223" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:48.9543%;margin-top:-7.6px;left:2.5046%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle20">T</span>ara<span class="g-cstyle3">p</span>ac<span class="g-cstyle3">á</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0221%;margin-top:-7.6px;left:44.0845%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0221%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0221%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0221%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0221%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-229" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:50.0398%;margin-top:-7.6px;left:2.5046%;width:122px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Norte<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.0398%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.0398%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.0398%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.0398%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.0398%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-235" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:51.0574%;margin-top:-7.6px;left:2.5046%;width:104px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Sa<span class="g-cstyle3">n</span> S<span class="g-cstyle3">e</span>b<span class="g-cstyle3">a</span>stián<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.1253%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.1253%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.1253%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.1253%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.1253%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-241" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:52.075%;margin-top:-7.6px;left:2.5046%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Ma<span class="g-cstyle3">y</span>or*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.1429%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.1429%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">5<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.1429%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.1429%;margin-top:-7.6px;left:74.136%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.1429%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-247" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:53.1605%;margin-top:-7.6px;left:2.5046%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Di<span class="g-cstyle3">eg</span>o<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>rtale<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1605%;margin-top:-7.6px;left:43.9682%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1605%;margin-top:-7.6px;left:52.9926%;width:45px;">
      <p class="g-pstyle2">40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1605%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1605%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.1605%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-253" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:54.1782%;margin-top:-7.6px;left:2.5046%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. An<span class="g-cstyle3">d</span><span class="g-cstyle12">r</span>és <span class="g-cstyle3">B</span>ello<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1782%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1782%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1782%;margin-top:-7.6px;left:62.5388%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1782%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1782%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-259" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:55.1958%;margin-top:-7.6px;left:2.5046%;width:128px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Be<span class="g-cstyle3">r</span>nard<span class="g-cstyle3">o</span> O&rsquo;Higgins<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2637%;margin-top:-7.6px;left:44.0845%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2637%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2637%;margin-top:-7.6px;left:62.5388%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2637%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2637%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-265" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:56.2134%;margin-top:-7.6px;left:2.5046%;width:97px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de O&rsquo;H<span class="g-cstyle3">i</span>ggins<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.2813%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.2813%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.2813%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.2813%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.2813%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-271" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:57.2989%;margin-top:-7.6px;left:2.5046%;width:110px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de Ma<span class="g-cstyle3">g</span>a<span class="g-cstyle3">l</span>la<span class="g-cstyle3">n</span>es*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.2989%;margin-top:-7.6px;left:44.1782%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.2989%;margin-top:-7.6px;left:53.1329%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.2989%;margin-top:-7.6px;left:62.655%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.2989%;margin-top:-7.6px;left:74.2523%;width:43px;">
      <p class="g-pstyle2">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.2989%;margin-top:-7.6px;left:89.3576%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-277" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:58.3165%;margin-top:-7.6px;left:2.5046%;width:132px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> de Ch<span class="g-cstyle3">i</span>le*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3844%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3844%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3844%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3844%;margin-top:-7.6px;left:74.136%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.3844%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-283" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:59.3342%;margin-top:-7.6px;left:2.5046%;width:109px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de An<span class="g-cstyle3">t</span><span class="g-cstyle21">o</span>faga<span class="g-cstyle3">s</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.4021%;margin-top:-7.6px;left:43.9444%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.4021%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.4021%;margin-top:-7.6px;left:62.5616%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.4021%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:59.4021%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-289" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:60.4197%;margin-top:-7.6px;left:2.5046%;width:94px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle12">A</span>tac<span class="g-cstyle3">a</span>ma<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.4197%;margin-top:-7.6px;left:44.0845%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.4197%;margin-top:-7.6px;left:53.0392%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.4197%;margin-top:-7.6px;left:62.4216%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.4197%;margin-top:-7.6px;left:77.0499%;width:25px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.4197%;margin-top:-7.6px;left:89.4739%;width:43px;">
      <p class="g-pstyle2">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-295" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4001%;margin-top:-6.8px;left:82.2168%;width:59px;">
      <p class="g-pstyle0"><span class="g-cstyle0">A</span>rancel<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-296" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:62.4002%;margin-top:-6.8px;left:42.2562%;width:60px;">
      <p class="g-pstyle8">Ra<span class="g-cstyle24">n</span>k<span class="g-cstyle24">in</span>g<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-297" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:63.1214%;margin-top:-8.4px;left:2.6447%;width:91px;">
      <p class="g-pstyle1">Univ<span class="g-cstyle0">e</span>r<span class="g-cstyle0">s</span>ida<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-298" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.1467%;margin-top:-6.8px;left:77.9761%;width:70px;">
      <p class="g-pstyle0">referen<span class="g-cstyle0">c</span>ia<span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai1-299" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.1465%;margin-top:-6.8px;left:56.2314%;width:64px;">
      <p class="g-pstyle8">Va<span class="g-cstyle24">c</span>a<span class="g-cstyle24">n</span>te<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-300" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.1461%;margin-top:-6.8px;left:44.1%;width:47px;">
      <p class="g-pstyle0">not<span class="g-cstyle0">a</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-301" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:64.9651%;margin-top:-7.6px;left:2.5046%;width:87px;">
      <p class="g-pstyle2">PUC de<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-302" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9668%;margin-top:-7.6px;left:75.4205%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span><span class="g-cstyle25">7</span><span class="g-cstyle3">.</span>35<span class="g-cstyle3">2</span><span class="g-cstyle8">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-303" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9656%;margin-top:-7.6px;left:60.9457%;width:37px;">
      <p class="g-pstyle3">85<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-304" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.9658%;margin-top:-7.6px;left:44.8517%;width:46px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-305" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:65.9828%;margin-top:-7.6px;left:2.5046%;width:134px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de San<span class="g-cstyle3">ti</span>ago de Chile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-306" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.9845%;margin-top:-7.6px;left:75.0516%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>2<span class="g-cstyle3">5</span><span class="g-cstyle8">0</span><span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-307" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.9832%;margin-top:-7.6px;left:60.8563%;width:38px;">
      <p class="g-pstyle3">60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-308" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.9834%;margin-top:-7.6px;left:44.7858%;width:47px;">
      <p class="g-pstyle3">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-309" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:67.0004%;margin-top:-7.6px;left:2.5046%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-310" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0699%;margin-top:-7.6px;left:75.3818%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6<span class="g-cstyle3">.</span>52<span class="g-cstyle25">7</span><span class="g-cstyle8">.</span>90<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-311" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0688%;margin-top:-7.6px;left:60.0214%;width:42px;">
      <p class="g-pstyle3">19<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-312" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.0689%;margin-top:-7.6px;left:44.8596%;width:46px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-313" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:68.0859%;margin-top:-7.6px;left:2.5046%;width:98px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de los <span class="g-cstyle3">A</span>ndes<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-314" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.0869%;margin-top:-7.6px;left:81.47%;width:58px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>85 UF<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-315" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.0863%;margin-top:-7.6px;left:60.8643%;width:38px;">
      <p class="g-pstyle3">60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-316" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.0865%;margin-top:-7.6px;left:45.0266%;width:44px;">
      <p class="g-pstyle3">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-317" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:69.1035%;margin-top:-7.6px;left:2.5046%;width:108px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de C<span class="g-cstyle3">o</span>ncepción<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-318" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1051%;margin-top:-7.6px;left:75.3195%;width:80px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6<span class="g-cstyle8">.</span>97<span class="g-cstyle3">6</span><span class="g-cstyle18">.</span>0<span class="g-cstyle3">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-319" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1041%;margin-top:-7.6px;left:60.0992%;width:42px;">
      <p class="g-pstyle3">1<span class="g-cstyle3">0</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-320" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.1042%;margin-top:-7.6px;left:44.96%;width:45px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-321" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:70.1212%;margin-top:-7.6px;left:2.5046%;width:102px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de<span class="g-cstyle3">l</span> De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle12">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-322" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.19%;margin-top:-7.6px;left:81.5475%;width:57px;">
      <p class="g-pstyle3">31<span class="g-cstyle3">4</span> U<span class="g-cstyle3">F</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-323" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.1894%;margin-top:-7.6px;left:60.9653%;width:37px;">
      <p class="g-pstyle3">65<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-324" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.1897%;margin-top:-7.6px;left:44.8712%;width:46px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-325" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:71.1388%;margin-top:-7.6px;left:2.5046%;width:98px;">
      <p class="g-pstyle4">U. de Valparaíso</p>
    </div>
    <div id="g-ai1-326" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2083%;margin-top:-7.6px;left:75.1407%;width:81px;">
      <p class="g-pstyle10">$5.539.000</p>
    </div>
    <div id="g-ai1-327" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.207%;margin-top:-7.6px;left:60.8759%;width:33px;">
      <p class="g-pstyle3">71</p>
    </div>
    <div id="g-ai1-328" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.2073%;margin-top:-7.6px;left:44.8981%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-329" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.2259%;margin-top:-7.6px;left:75.1407%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle18">.</span>618<span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-330" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.2247%;margin-top:-7.6px;left:60.8759%;width:38px;">
      <p class="g-pstyle3">46<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-331" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.225%;margin-top:-7.6px;left:44.8981%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-332" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:72.2243%;margin-top:-7.6px;left:2.5046%;width:111px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Au<span class="g-cstyle3">s</span>tral<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-333" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2436%;margin-top:-7.6px;left:75.4477%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle8">.</span>78<span class="g-cstyle25">7</span><span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-334" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2424%;margin-top:-7.6px;left:60.9729%;width:37px;">
      <p class="g-pstyle3">56<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-335" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.2426%;margin-top:-7.6px;left:44.9017%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-336" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:73.3098%;margin-top:-7.6px;left:2.5046%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de La <span class="g-cstyle18">F</span><span class="g-cstyle12">r</span>o<span class="g-cstyle3">n</span>tera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-337" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.3291%;margin-top:-7.6px;left:75.0787%;width:83px;">
      <p class="g-pstyle11"><span class="g-cstyle3">$</span><span class="g-cstyle25">7</span>.<span class="g-cstyle10">9</span><span class="g-cstyle3">0</span>0.<span class="g-cstyle3">0</span><span class="g-cstyle10">00</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-338" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.3278%;margin-top:-7.6px;left:60.8835%;width:38px;">
      <p class="g-pstyle3">60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-339" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.3281%;margin-top:-7.6px;left:44.9756%;width:45px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-340" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:74.3274%;margin-top:-7.6px;left:2.5046%;width:136px;">
      <p class="g-pstyle2">UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>la<span class="g-cstyle3"> </span>S. C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epció<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-341" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.3467%;margin-top:-7.6px;left:74.7794%;width:84px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6<span class="g-cstyle3">.</span>344<span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-342" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.3455%;margin-top:-7.6px;left:61.0742%;width:36px;">
      <p class="g-pstyle3">75<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-343" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.3457%;margin-top:-7.6px;left:44.9796%;width:45px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-344" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:75.345%;margin-top:-7.6px;left:2.5046%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle20">T</span>alca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-345" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.3643%;margin-top:-7.6px;left:75.1321%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6<span class="g-cstyle8">.</span>7<span class="g-cstyle3">6</span>3<span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-346" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.3631%;margin-top:-7.6px;left:60.9845%;width:37px;">
      <p class="g-pstyle3">70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-347" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.3633%;margin-top:-7.6px;left:44.9133%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-348" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:76.4305%;margin-top:-7.6px;left:2.5046%;width:124px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Maule<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-349" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.382%;margin-top:-7.6px;left:75.0198%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8.<span class="g-cstyle3">5</span>5<span class="g-cstyle8">0</span><span class="g-cstyle18">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-350" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.4486%;margin-top:-7.6px;left:60.9885%;width:37px;">
      <p class="g-pstyle3">70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-351" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.4488%;margin-top:-7.6px;left:44.8944%;width:46px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-352" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:77.4482%;margin-top:-7.6px;left:2.5046%;width:91px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Fi<span class="g-cstyle3">n</span>is <span class="g-cstyle22">T</span>erra<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-353" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.4675%;margin-top:-7.6px;left:75.1868%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>595<span class="g-cstyle18">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-354" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.4663%;margin-top:-7.6px;left:60.9457%;width:38px;">
      <p class="g-pstyle3">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-355" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.4665%;margin-top:-7.6px;left:44.8285%;width:47px;">
      <p class="g-pstyle3">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-356" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:78.4658%;margin-top:-7.6px;left:2.5046%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle20">T</span>ara<span class="g-cstyle3">p</span>ac<span class="g-cstyle3">á</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-357" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.4852%;margin-top:-7.6px;left:74.8416%;width:84px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>80<span class="g-cstyle8">0</span><span class="g-cstyle18">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-358" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.4839%;margin-top:-7.6px;left:60.903%;width:38px;">
      <p class="g-pstyle3">48<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-359" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.4841%;margin-top:-7.6px;left:44.9252%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-360" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:79.5513%;margin-top:-7.6px;left:2.5046%;width:122px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Norte<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-361" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.5027%;margin-top:-7.6px;left:74.9847%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8.<span class="g-cstyle3">1</span>4<span class="g-cstyle8">0.</span>9<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-362" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.5016%;margin-top:-7.6px;left:60.1846%;width:41px;">
      <p class="g-pstyle3">11<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-363" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.5017%;margin-top:-7.6px;left:44.9289%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-364" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:80.5689%;margin-top:-7.6px;left:2.5046%;width:104px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Sa<span class="g-cstyle3">n</span> S<span class="g-cstyle3">e</span>b<span class="g-cstyle3">a</span>stián<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-365" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.5882%;margin-top:-7.6px;left:75.5017%;width:80px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span><span class="g-cstyle25">7</span><span class="g-cstyle8">.</span>9<span class="g-cstyle3">0</span><span class="g-cstyle13">9</span><span class="g-cstyle3">.</span>160<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-366" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.587%;margin-top:-7.6px;left:60.9106%;width:38px;">
      <p class="g-pstyle3">60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-367" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.5872%;margin-top:-7.6px;left:44.9796%;width:45px;">
      <p class="g-pstyle3">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-368" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:81.5866%;margin-top:-7.6px;left:2.5046%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Ma<span class="g-cstyle3">y</span>or*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-369" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.6059%;margin-top:-7.6px;left:74.9466%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8<span class="g-cstyle8">.</span>70<span class="g-cstyle3">8</span><span class="g-cstyle8">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-370" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.6046%;margin-top:-7.6px;left:61.008%;width:37px;">
      <p class="g-pstyle3">70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-371" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.6048%;margin-top:-7.6px;left:44.9835%;width:45px;">
      <p class="g-pstyle3">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-372" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:82.672%;margin-top:-7.6px;left:2.5046%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Di<span class="g-cstyle3">eg</span>o<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>rtale<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-373" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.6235%;margin-top:-7.6px;left:75.206%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8<span class="g-cstyle8">.</span>96<span class="g-cstyle26">7</span><span class="g-cstyle8">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-374" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.6223%;margin-top:-7.6px;left:60.965%;width:37px;">
      <p class="g-pstyle3">96<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-375" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.6225%;margin-top:-7.6px;left:44.9405%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-376" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:83.6897%;margin-top:-7.6px;left:2.5046%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. An<span class="g-cstyle3">d</span><span class="g-cstyle12">r</span>és <span class="g-cstyle3">B</span>ello<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-377" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.7089%;margin-top:-7.6px;left:75.2338%;width:80px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8.<span class="g-cstyle3">1</span>1<span class="g-cstyle8">0</span><span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-378" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.7078%;margin-top:-7.6px;left:60.9222%;width:38px;">
      <p class="g-pstyle3">60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-379" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.708%;margin-top:-7.6px;left:44.9445%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-380" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:84.7073%;margin-top:-7.6px;left:2.5046%;width:128px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Be<span class="g-cstyle3">r</span>nard<span class="g-cstyle3">o</span> O&rsquo;Higgins<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-381" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.7267%;margin-top:-7.6px;left:75.051%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>39<span class="g-cstyle8">0</span><span class="g-cstyle18">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-382" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.7254%;margin-top:-7.6px;left:60.9262%;width:38px;">
      <p class="g-pstyle3">80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-383" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.7257%;margin-top:-7.6px;left:44.9484%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-384" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:85.725%;margin-top:-7.6px;left:2.5046%;width:97px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de O&rsquo;H<span class="g-cstyle3">i</span>ggins<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-385" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.7443%;margin-top:-7.6px;left:75.148%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle18">.</span>091<span class="g-cstyle18">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-386" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.743%;margin-top:-7.6px;left:61.0004%;width:38px;">
      <p class="g-pstyle10"><span class="g-cstyle10">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-387" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.7433%;margin-top:-7.6px;left:45.022%;width:45px;">
      <p class="g-pstyle3"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-388" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:86.8104%;margin-top:-7.6px;left:2.5046%;width:110px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de Ma<span class="g-cstyle3">g</span>a<span class="g-cstyle3">l</span>la<span class="g-cstyle3">n</span>es*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-389" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.7619%;margin-top:-7.6px;left:75.0586%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span><span class="g-cstyle25">7</span><span class="g-cstyle3">.</span>448<span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-390" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.8285%;margin-top:-7.6px;left:61.0043%;width:38px;">
      <p class="g-pstyle10"><span class="g-cstyle10">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-391" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.8287%;margin-top:-7.6px;left:44.9561%;width:46px;">
      <p class="g-pstyle3">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-392" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:87.8281%;margin-top:-7.6px;left:2.5046%;width:132px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> de Ch<span class="g-cstyle3">i</span>le*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-393" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.8474%;margin-top:-7.6px;left:75.3189%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle8">.</span>7<span class="g-cstyle14">7</span>4<span class="g-cstyle18">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-394" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.8462%;margin-top:-7.6px;left:61.0779%;width:37px;">
      <p class="g-pstyle3">35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-395" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.8464%;margin-top:-7.6px;left:44.8672%;width:47px;">
      <p class="g-pstyle3">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-396" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:88.8457%;margin-top:-7.6px;left:2.5046%;width:109px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de An<span class="g-cstyle3">t</span><span class="g-cstyle21">o</span>faga<span class="g-cstyle3">s</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-397" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.865%;margin-top:-7.6px;left:75.2292%;width:80px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>3<span class="g-cstyle3">2</span>2<span class="g-cstyle18">.</span>00<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-398" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8638%;margin-top:-7.6px;left:60.9882%;width:37px;">
      <p class="g-pstyle3">45<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-399" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:89.8641%;margin-top:-7.6px;left:44.8709%;width:47px;">
      <p class="g-pstyle3">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-400" class="g-Layer_3 g-aiAbs g-aiPointText" style="top:89.9312%;margin-top:-7.6px;left:2.5046%;width:94px;">
      <p class="g-pstyle2"><span class="g-cstyle7">U</span>. de <span class="g-cstyle12">A</span>tac<span class="g-cstyle3">a</span>ma<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-401" class="g-Layer_1 g-aiAbs" style="top:90.7734%;left:2.5%;width:95%;">
      <p class="g-pstyle12">Fuente: Información proporcionada por cada casa de estudio, la cual corresponde a la jornada diurna / En algunos casos los aranceles y vacantes corresponden al año 2021 / (*) Piden una de las dos pruebas optativas / La información de las universidades de Magallanes y de Santiago de Chile fue extraída de sus portales &mdash;www.umag.cl y www.usach.cl&mdash;. Mientras en la primera el puntaje de corte corresponde al último matriculado, en la segunda se explica que es del último seleccionado. Asimismo, los aranceles de la USACh corresponden a los deciles 7, 8 y 9.</p>
    </div>
  </div>


</div>
`

const containerId = 'g-medicina-box'
const namespace = 'g-'
const name = 'medicina'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-12-23 02:24 */
